import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { forkJoin } from 'rxjs';
import { CertificateTypeDto } from 'src/app/data-transfer/entities/certificate-type-dto';
import { CountryDto } from 'src/app/data-transfer/entities/country-dto';
import { TagDto } from 'src/app/data-transfer/entities/tag-dto';
import { BaseDataApiService } from 'src/app/data-transfer/services/base-data-api-service';
import { TagApiService } from 'src/app/data-transfer/services/tag-api-service';
import { DialogActions } from 'src/app/model/dictionary';

@Component({
  selector: 'app-header-info-dialog',
  templateUrl: './header-info-dialog.component.html',
  styleUrls: ['./header-info-dialog.component.scss'],
})
export class HeaderInfoDialogComponent {
  public headerInfoData: any;
  public allTags?: TagDto[];
  public allCertificateTypes: CertificateTypeDto[] = [];
  public allDistributionCountries: CountryDto[] = [];
  public allManufacturingCountries: CountryDto[] = [];

  public associatedTagIdentifiers: number[] = [];
  public distributionCountries: string = '';
  public manufacturingCountry: string = '';
  public totalGrammage?: number;

  public isLoading = true;

  constructor(
    private dialogRef: MatDialogRef<HeaderInfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    tagService: TagApiService,
    baseDataService: BaseDataApiService
  ) {
    this.headerInfoData = data.headerInfoData;

    forkJoin({
      tags: tagService.getAllTags(),
      certificateTypes: baseDataService.getCertificateTypes(),
      distributionCountries: baseDataService.getDistributionCountries(),
      manufacturingCountries: baseDataService.getManufacturingCountries(),
    }).subscribe(({ tags, certificateTypes, distributionCountries, manufacturingCountries }) => {
      this.allCertificateTypes = certificateTypes;
      this.allTags = tags;
      this.allDistributionCountries = distributionCountries;
      this.allManufacturingCountries = manufacturingCountries;
      this.associatedTagIdentifiers = this.headerInfoData.associatedTagIdentifiers;

      if (this.headerInfoData.totalGrammage != null) {
        this.totalGrammage = this.headerInfoData.totalGrammage;
      } else {
        this.totalGrammage = this.headerInfoData.multiMaterial?.totalGrammage;
      }

      const distributionCountryCodes = this.headerInfoData.distributionCountries;
      if (distributionCountryCodes != null && distributionCountryCodes.length > 0) {
        this.distributionCountries = this.allDistributionCountries
          .filter(country => distributionCountryCodes.includes(country.code))
          .map(country => country.name)
          .join(', ');
      }

      if (this.headerInfoData.manufacturingCountry != null) {
        this.manufacturingCountry = this.allManufacturingCountries.find(country => this.headerInfoData.manufacturingCountry.includes(country.code))?.name ?? '';
      }
    });

    this.isLoading = false;
  }

  getTagsFromIds(ids: number[]): TagDto[] {
    return this.allTags?.filter(tag => ids.includes(tag.id ?? -1)) ?? [];
  }

  closeDialog() {
    this.dialogRef.close({ event: DialogActions.REJECT });
  }
}
